<template>
  <div v-cloak id="app">
    <DotLoading class="app_dot_loading" />
    <UpdatePopup />
    <SnackBar />
    <PopUp
      v-if="_errorMessage"
      style="z-index: 3000"
      :title="_errorMessage"
      :pop-up-active="_errorPopupActive"
      :noCloseIcon="!_errorCloseBtn"
      :isLoading="isLoading.errorPopup"
      notice
      @click="$_goBackClick()"
    >
      <LlCancelPopupContent v-if="_errorBtnText">
        <template v-slot:buttons>
          <WsButton001 :isloading="isLoading.errorPopup" @click="$_goBackClick()">
            {{ _errorBtnText }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <PopUp
      bottom
      title="已閒置一段時間未瀏覽"
      :style="{ 'z-index': '3001' }"
      :popUpActive="idlePopup.alertActive"
      @click="$_idleReset()"
    >
      <p>
        {{ $t(`是否要繼續使用此平台，否則在 {number} 秒後將自動登出。`, { number: leaveCount }) }}
      </p>
      <template #bottomBtn>
        <WsButton001 out-line @click="$_immediateSignOut()">
          {{ $t('登出') }}
        </WsButton001>
        <WsButton001 @click="$_idleReset()">
          {{ $t('繼續使用') }}
        </WsButton001>
      </template>
    </PopUp>
    <PopUp no-close-icon :pop-up-active="idlePopup.restartActive" :title="$t('已閒置過久')" bottom>
      <p>{{ $t('為了保護您的資料安全，已登出本系統，請重新登入。') }}</p>
      <template #bottomBtn>
        <WsButton001 @click="$_idleRestartPopupClose()">
          {{ $t('重新登入') }}
        </WsButton001>
      </template>
    </PopUp>
    <!-- invalid scope popup -->
    <PopUp
      style="z-index: 2001"
      :pop-up-active="_invalidPopupActive"
      :title="$t('您無此權限')"
      bottom
      @click="$_invalidScopePopupClose()"
    >
      <template #bottomBtn>
        <WsButton001 @click="$_invalidScopePopupClose()">
          {{ $t('知道了') }}
        </WsButton001>
      </template>
    </PopUp>
    <!-- sos popup -->
    <SosPopup :pop-up-active="_sosPopupActive" style="z-index: 2001" />
    <!-- download popup（由 file.js download() 透過 store 驅動） -->
    <LvWarningPopup
      :visible="_downloadPopupActive"
      :title="_downloadPopupMessage"
      :isLoading="_downloadPopupLoading"
      :clickOutsideClose="!_downloadPopupLoading"
      @confirm="$_onDownloadPopupClose"
      @close="$_onDownloadPopupClose"
    />
    <!-- temp hide -->
    <!-- <DownloadAppLayout v-if="_template === 'auth' && window.width < 768" />
    <GeneralLayout v-else-if="_template === 'auth'" /> -->
    <GeneralLayout v-if="_template === 'auth'" />
    <PrintingLayout v-else-if="_template === 'printing'" />
    <LoginLayout v-else />
  </div>
</template>
<script>
import SnackBar from '@/components/SnackBar';
import GeneralLayout from '@/layouts/GeneralLayout';
import LoginLayout from '@/layouts/LoginLayout';
import PrintingLayout from '@/layouts/PrintingLayout';
import S_auth from '@/__vue2stone/service/api/v1/auth';
import H_common from '@/helpers/common';
import { errorMessageMap } from '@/spare/error';

const IDLE_LOGOUT_COUNTDOWN = 60;

export default {
  components: {
    // DownloadAppLayout,
    GeneralLayout,
    LoginLayout,
    SnackBar,
    PrintingLayout,
  },
  data: () => ({
    isLoading: {
      errorPopup: false,
    },
    window: {
      width: 0,
      height: 0,
    },
    count: 0,
    currentCount: 0,
    leaveCount: 0,
    idlePopup: {
      alertActive: false,
      restartActive: false,
    },
    leaveTabTime: null,
    backToTabTime: null,
    checkVerInterval: null,
    token: localStorage.getItem('access_token'),
  }),
  computed: {
    _currentUser() {
      let _currentUser = null;
      if (
        this.$store.state.stone_auth.currentUser &&
        this.$store.state.stone_auth.currentUser.locale
      ) {
        _currentUser = this.$store.state.stone_auth.currentUser;
      } else {
        _currentUser = {
          locale: {
            code: 'tw',
          },
        };
      }
      return _currentUser;
    },
    _errorPopupActive() {
      return this.$store.state.error.isError;
    },
    _sosPopupActive() {
      return this.$store.state.sospopup.popupActive;
    },
    _invalidPopupActive() {
      return this.$store.state.invalidpopup.popupActive;
    },
    _downloadPopupActive() {
      return this.$store.state.downloadPopup.popupActive;
    },
    _downloadPopupMessage() {
      return this.$store.state.downloadPopup.message;
    },
    _downloadPopupLoading() {
      return this.$store.state.downloadPopup.isLoading;
    },
    _template() {
      if (this.$route.meta && this.$route.meta.template) {
        return this.$route.meta.template;
      } else {
        return 'App';
      }
    },

    _errorMessage() {
      const errorMessage = this.$store.state.error.errorMessage;
      if (errorMessageMap.has(errorMessage)) {
        return errorMessageMap.get(errorMessage);
      }
      return errorMessage || '';
    },
    _errorBtnText() {
      const errorMessage = this.$store.state.error.errorMessage;
      if (errorMessage === 'no data.') {
        return this.$t('返回');
      } else if (
        errorMessage === 'invalid scopes' ||
        errorMessage === 'invalid factory scopes' ||
        errorMessage === 'invalid organization scopes' ||
        errorMessage === 'Too Many Attempts.'
      ) {
        return this.$t('知道了');
      } else if (errorMessage === 'no scopes') {
        return this.$t('登出');
      } else {
        return '';
      }
    },
    _errorCloseBtn() {
      return this.$store.state.error.errorMessage === 'no scopes' ? false : true;
    },
    _idleSeconds() {
      return Number(this.$store.state.app.factory?.idleSeconds) || 0;
    },
  },
  watch: {
    _currentUser: {
      handler() {
        if (this._currentUser && this._currentUser.locale && this._currentUser.locale.code) {
          this.$root.$i18n.locale = this._currentUser.locale.code;
        } else {
          this.$root.$i18n.locale = 'tw';
        }
      },
      deep: true,
    },
    '_currentUser.id'(newVal) {
      if (newVal) {
        this.$_setIdleTime();
      } else {
        this.$_clearInterval();
        this.$_clearTabTime();
      }
    },
    token(newVal) {
      if (!newVal) this.$_signOut();
    },
    _idleSeconds() {
      if (this._currentUser && this._currentUser.id) this.$_setIdleTime();
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  async mounted() {
    await H_common.checkAppVersion();
    window.addEventListener('storage', this.$_handleTokenChange);
    window.addEventListener('mousemove', this.$_resetIdleCount);
    window.addEventListener('keydown', this.$_resetIdleCount);
    window.addEventListener('touchstart', this.$_resetIdleCount, { passive: true });
    window.addEventListener('scroll', this.$_resetIdleCount, { capture: true, passive: true });
    document.addEventListener('visibilitychange', this.$_setVisibleIdleTime);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.$_handleTokenChange);
    window.removeEventListener('resize', this.handleResize);
    clearInterval(window.timer);
    clearInterval(this.checkVerInterval);
    window.removeEventListener('mousemove', this.$_resetIdleCount);
    window.removeEventListener('keydown', this.$_resetIdleCount);
    window.removeEventListener('touchstart', this.$_resetIdleCount);
    window.removeEventListener('scroll', this.$_resetIdleCount, { capture: true });
    document.removeEventListener('visibilitychange', this.$_setVisibleIdleTime);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    async $_goBackClick() {
      const errorMessage = this.$store.state.error.errorMessage;
      const isOperational = this.$store.state.error.isOperational;
      if (errorMessage === 'no scopes') this.$_signOut();
      if (errorMessage === 'no data.' || (errorMessage === 'invalid scopes' && !isOperational)) {
        this.isLoading.errorPopup = true;
        await S_auth.getUser();
        this.isLoading.errorPopup = false;
        this.$_goBackToPreviousRoute();
      }
      if (
        !isOperational &&
        (errorMessage === 'invalid factory scopes' ||
          errorMessage === 'invalid organization scopes')
      ) {
        const availableFactory = this.$store.state.stone_auth.currentUser?.factory_ids?.[0];
        if (typeof availableFactory === 'string') {
          this.$router.push(`/factory/${availableFactory}/board-overview`);
        } else {
          this.$router.push('/not-found');
        }
      }
      this.$store.dispatch('error/setErrorFalse');
      this.$store.dispatch('error/setIsOperationalFalse');
      this.$store.dispatch('error/setErrorMessage', null);
    },
    $_goBackToPreviousRoute() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },
    $_resetIdleCount() {
      if (this.count >= this._idleSeconds) return;
      this.count = 0;
    },
    $_setIdleTime() {
      this.$_clearInterval();
      this.leaveCount = IDLE_LOGOUT_COUNTDOWN;
      if (!this._idleSeconds) return;
      window.timer = setInterval(() => {
        if (this._currentUser && this._currentUser.id) {
          this.count++;
        } else {
          this.$_clearInterval();
        }
        if (this.count >= this._idleSeconds) {
          this.$_idleAlertPopupOpen();
          if (this.leaveCount > 0) {
            this.leaveCount--;
          }
        }
        if (this.count >= this._idleSeconds + IDLE_LOGOUT_COUNTDOWN) {
          this.$_clearInterval();
          this.$_idleAlertPopupClose();
          this.$_idleRestartPopupOpen();
          this.$_signOut();
        }
      }, 1000);
    },
    $_idleAlertPopupOpen() {
      this.idlePopup.alertActive = true;
    },
    $_idleAlertPopupClose() {
      this.idlePopup.alertActive = false;
    },
    $_idleRestartPopupOpen() {
      this.idlePopup.restartActive = true;
    },
    $_idleRestartPopupClose() {
      this.$_signOut();
      this.idlePopup.restartActive = false;
    },
    $_clearInterval() {
      this.count = 0;
      clearInterval(window.timer);
    },
    $_idleReset() {
      this.$_setIdleTime();
      this.$_idleAlertPopupClose();
    },
    $_signOut() {
      this.$router.push('/signout');
    },
    $_immediateSignOut() {
      this.$_clearInterval();
      this.$_idleAlertPopupClose();
      this.$router.push('/signout');
    },
    $_invalidScopePopupClose() {
      this.$store.dispatch('invalidpopup/closeInvalidPopup');
    },
    $_onDownloadPopupClose() {
      this.$store.dispatch('downloadPopup/close');
    },
    $_setVisibleIdleTime(e) {
      if (e.target.visibilityState === 'hidden' && this._currentUser && this._currentUser.id) {
        this.leaveTabTime = this.$moment(new Date()).unix();
        this.currentCount = this.count;
      }
      if (e.target.visibilityState === 'visible' && this._currentUser && this._currentUser.id)
        this.backToTabTime = this.$moment(new Date()).unix();
      const timeGap = this.backToTabTime - this.leaveTabTime;
      if (this.leaveTabTime !== null && this.backToTabTime !== null && timeGap > 0) {
        this.count = this.currentCount + timeGap;
        const logoutCount = this._idleSeconds + IDLE_LOGOUT_COUNTDOWN;
        if (this.count >= this._idleSeconds && this.count < logoutCount) {
          this.leaveCount = logoutCount - this.count;
        }
      }
    },
    $_handleTokenChange(event) {
      if (event.key === 'access_token') this.token = event.newValue;
    },
    $_clearTabTime() {
      this.leaveTabTime = null;
      this.backToTabTime = null;
    },
  },
};
</script>
<style lang="scss">
@import '@wasateam/wsscssstone/app';
@import 'assets/icomoon/style.css';
@import '@/assets/scss/app.scss';
@import '@/__vue2stone/scss/app.scss';
</style>
